import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthTokenRequest = object('AuthTokenRequest', {
  tenant: string(),
  realm: string(),
  provider: string(),
  token: string(),
});
